var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-stories',{key:_vm.storyRouteId,attrs:{"story":_vm.story,"from-end":_vm.isFromEnd},on:{"nextStory":_vm.onNextStory,"previousStory":_vm.onPreviousStory}})
}
var staticRenderFns = []

export { render, staticRenderFns }